<template>
  <file-input v-bind="$attrs" @change="fileChange" ref="fileUpload" />
</template>

<script>
import Swal from "sweetalert2";

export default {
  name: "FileLoader",
  props: {
    maxSize: Number,
    parseJson: Boolean,
    rawBytes: {
    type: Boolean,
    default: false
  }
  },
  methods: {
    fileChange(files) {
      if (files.length === 0) return;
      
      const file = files[0];  // Store file reference
      
      if (file.size > this.maxSize) {
        Swal.fire({text: `File is too big. Only files up to ${this.maxSize} Bytes are allowed.`});
        this.clearFile();
        return;
      }

      const reader = new FileReader();
      reader.addEventListener("load", () => {
        this.fileRead(reader.result, file);  // Pass file to fileRead
      }, false);

      if (this.rawBytes) {
      // Use this for binary files (e.g., firmware, images)
      reader.readAsArrayBuffer(file);
    } else {
      // Use this for text-based files (e.g., JSON)
      reader.readAsText(file);
    }
    },

    fileRead(result, file) {  // Accept file parameter
      if (!this.parseJson) {
        this.$emit('update:content', result);
        this.$emit('file-loaded', result, file.name);  // Now file is defined
        return;
      }
      
      try {
        const content = JSON.parse(result);
        this.$emit('update:content', content);
      } catch (e) {
        Swal.fire({text: e.message});
        this.clearFile();
      }
    },

    clearFile() {
      this.$emit('update:content', null);
      this.$refs.fileUpload.value = null;
      this.$emit('file-loaded', null, null);
    },
  }
}
</script>